import {Component, EventEmitter, Output} from '@angular/core';
@Component({
    selector: 'app-endcustomer-downgrade-order-complete',
    templateUrl: './endcustomer-downgrade-order-complete.component.html',
    standalone: false
})
export class EndcustomerDowngradeOrderCompleteComponent {
  @Output() next = new EventEmitter();
}
